import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  ApplicationResponse,
  StateTrackedData,
} from "@src/common/domain/common.model";
import api from "@src/common/services/api.service";
import AppConstants from "@src/utils/app.constants";
import { PlantModelRef } from "../domain/plant-model";
export type PlantStore = {
  minimal: StateTrackedData<any[]>;
};
export const createPlant = createAsyncThunk<void, any>(
  "plant/createPlant",
  async (payload: any) => {
    const url = `${AppConstants.api}/plant`;
    const response = await api.post<ApplicationResponse<any>>(url, payload);
    return response.data.data || [];
  }
);
export const updatePlant = createAsyncThunk<void, any>(
  "plant/createPlant",
  async (payload: any) => {
    const url = `${AppConstants.api}/plant`;
    const response = await api.put<ApplicationResponse<any>>(url, payload);
    return response.data.data || [];
  }
);
export const deletePlant = createAsyncThunk(
  "plant/deletePlant",
  async (id: string) => {
    try {
      const response = await api.delete<ApplicationResponse<any[]>>(
        `${AppConstants.api}/plant?id=${id}`
      );
      return response.data.data || [];
    } catch (err) {
      return [];
    }
  }
);
export const fetchPlantList = createAsyncThunk<any[], void>(
  "plant/fetchPlant",
  async () => {
    const response = await api.get<ApplicationResponse<PlantModelRef[]>>(
      `${AppConstants.api}/plant`
    );
    return response.data.data || [];
  }
);

const plantSlice = createSlice({
  name: "plant",
  initialState: {
    minimal: { status: "loading", error: null, data: [] },
  } as PlantStore,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPlantList.pending, (state, action) => {
        state.minimal = {
          status: "loading",
          data: [],
          error: null,
        };
      })
      .addCase(fetchPlantList.fulfilled, (state, action) => {
        state.minimal = {
          status: "idle",
          data: action.payload,
          error: null,
        };
      })
      .addCase(fetchPlantList.rejected, (state, action) => {
        state.minimal = {
          status: "failed",
          data: [],
          error: action.error,
        };
      });
  },
});

export default plantSlice.reducer;
